// FILE: src/pages/ForbiddenPage.jsx
import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import PublicLayout from "../layouts/PublicLayout";
import { homeFor } from "./NotFoundPage";

export default function ForbiddenPage() {
  const role = useSelector((s) => s.auth.role);
  const home = homeFor(role);
  return (
    <PublicLayout>
      <Card sx={{ borderRadius: 4 }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography sx={{ color: "text.secondary", fontWeight: 600, mb: 1 }}>Error 403</Typography>
          <Typography variant="h1" sx={{ mb: 1 }}>
            You don't have access to this page
          </Typography>
          <Typography sx={{ color: "text.secondary", mb: 3 }}>
            This part of the site is for a different kind of account.
          </Typography>
          <Button component={RouterLink} to={home.to} variant="contained" size="large">
            {home.label}
          </Button>
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
